import PropTypes from 'prop-types';
import { seedDashboard3DrawersIcons } from '../../icon/seed-icons';

export const d3dPopoverMenusPropTypes = PropTypes.arrayOf(PropTypes.shape({
  Icon: PropTypes.object.isRequired,
  titleId: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
}));

export const defaultD3dPopoverMenusPropTypes = [
  {
    Icon: seedDashboard3DrawersIcons.Settings,
    titleId: 'seed.menu.settings',
    href: '/settings',
  },
];

export const dashboard3DrawersIconsPropTypes = PropTypes.shape({
  ArrowBack: PropTypes.object.isRequired,
  Input: PropTypes.object.isRequired,
  Menu: PropTypes.object.isRequired,
  Settings: PropTypes.object.isRequired,
  ExpandMore: PropTypes.object.isRequired,
  ExpandLess: PropTypes.object.isRequired,
});

export const drawerRoutesPropTypes = PropTypes.arrayOf(
  PropTypes.oneOfType([
    // section
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      routes: PropTypes.arrayOf(
        PropTypes.shape({
          path: PropTypes.string.isRequired,
          labelId: PropTypes.string.isRequired,
          Icon: PropTypes.object.isRequired,
          nested: PropTypes.bool,
          routes: PropTypes.arrayOf(
            PropTypes.shape({
              path: PropTypes.string.isRequired,
              labelId: PropTypes.string.isRequired,
              Icon: PropTypes.object,
            }),
          ),
        }),
      ),
    }),
    // divider
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      divider: PropTypes.bool.isRequired,
    }),
  ]),
);
